<template>
  <div class="col-12 col-lg-8 cycle-tabs-content" v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: {
    name: { required: true },
    selected: Boolean
  },
  data() {
    return {
      isActive: false
    };
  },
  mounted() {
    this.isActive = this.selected;
  }
}
</script>

<style lang="scss" scoped>
  .cycle-tabs-content {
    max-height: initial;
    opacity: 1;
    padding-bottom: 0;
    padding-top: 0;
    position: relative;
    top: 0;
    visibility: visible;
  }
</style>
